/**
 * Déclenche le téléchargement d'un blob côté navigateur.
 * Motif extrait de `V3/Food/Carte.vue::exportData` pour être partagé.
 *
 * @param {Blob|ArrayBuffer|string} data - corps de la réponse (`responseType: 'blob'`)
 * @param {string} fileName - nom de fichier proposé au navigateur
 * @param {string} [mimeType] - type MIME du blob (par défaut celui du blob reçu)
 */
export default function downloadBlob(data, fileName, mimeType) {
    const blob = data instanceof Blob && !mimeType ? data : new Blob([data], mimeType ? { type: mimeType } : undefined)
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
}

/**
 * Extrait le nom de fichier d'un en-tête `Content-Disposition`.
 *
 * @param {string|undefined} header
 * @param {string} fallback
 * @returns {string}
 */
export function fileNameFromDisposition(header, fallback) {
    if (!header) return fallback
    const match = header.match(/filename\*?=(?:UTF-8'')?(?:"([^"]+)"|([^;]+))/i)
    if (!match) return fallback
    const raw = (match[1] || match[2] || '').trim()
    try {
        return decodeURIComponent(raw) || fallback
    } catch (e) {
        return raw || fallback
    }
}
